import type { FC } from 'react';

import { useLinkComponent } from '@eneco/link';
import { NavLink, Stack } from '@eneco/sparky';
import { ComponentProps } from '@sitecore/types/lib';
import { SideNavRendering } from '@sitecore/types/SideNav';

type Props = ComponentProps & SideNavRendering;

export const SideNav: FC<Props> = ({ fields }) => {
  const Link = useLinkComponent();
  const sidebarLinks = fields.items.map(item => ({ ...item.fields.link.value, active: item.active }));

  return (
    //TODO: Add a good aria-label to indicate the type of nav
    <nav>
      <Stack gap="2" as="ul">
        {sidebarLinks.map(({ text, href, active, linktype }) => (
          <li key={href}>
            <Link href={href} linkType={linktype}>
              <NavLink variant="secondary" isCurrent={active}>
                {text}
              </NavLink>
            </Link>
          </li>
        ))}
      </Stack>
    </nav>
  );
};

export default SideNav;
